module.exports = __webpack_public_path__ + "static/img/logo_bosh_bg.8f24ed0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_bosh_bg.png
// module id = TbSM
// module chunks = 1